// GroupSelect.tsx
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useFetch } from "../../../hooks/useFetch";
import { api as groupApi } from "../../../api/groupApi";
import { Group } from "../../../types/group";
import { useTranslation } from 'react-i18next';

interface GroupSelectProps {
  selectedGroupId: number | null;
  onSelect: (groupId: number) => void;
}

export const GroupSelect: React.FC<GroupSelectProps> = ({ selectedGroupId, onSelect }) => {
  const { t } = useTranslation();
  
  const { data: groups } = useFetch<Group[]>(groupApi.get, []);

  const handleChange = (event: SelectChangeEvent<number | ''>) => {
    const value = event.target.value;
    if (value !== '' && typeof value === 'number') {
      onSelect(value);
    }
  };

  // Щоб MUI Select працював коректно, використовуємо `number | ''` для значення,
  // де '' представляє `null` (нічого не вибрано)
  const selectValue = selectedGroupId ?? '';

  return (
    <FormControl fullWidth>
      {/* <InputLabel id="group-select-label">Група</InputLabel> */}
      <Select<number | ''>
        labelId="group-select-label"
        id="group-select"
        value={selectValue}
        // label="Група"
        onChange={handleChange}
        // Дозволяє вибирати "порожній" елемент, якщо selectedGroupId === null
        displayEmpty 
      >
        <MenuItem value="" disabled>
          {t('GroupSelect.SelectGroup')}
        </MenuItem>
        {groups.map((group) => (
          <MenuItem 
            key={group.group_id} 
            value={group.group_id}
          >
            {group.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};